<template>
  <div class="WorldBabylon" @click="toogle = !toogle">  
    <canvas id="renderCanvas" ref="canvas" :class="{ over: toogle }"></canvas>
  </div>
</template>

<script>

import gsap from "gsap"
import 'babylonjs-materials'
import 'babylonjs-loaders'
import { Engine, Scene, Color3, FreeCamera, Vector3, HemisphericLight, Mesh, MeshBuilder, SceneLoader, DirectionalLight, PointLight } from 'babylonjs'

export default {

  name: 'WorldBabylon',
  data: ()=>({
    ready: false,
    toogle: false
  }),
  beforeDestroy() {
    // if(this.$scene)
    //   this.$scene.dispose()
  },

  mounted: async function() {




    console.log('WorldBabylon');

    const canvas = this.$refs.canvas
    const engine = new Engine(canvas, true, { preserveDrawingBuffer: true, stencil: true })
    const scene = new Scene(engine)
          scene.createDefaultCameraOrLight(false, true, true)
          scene.clearColor = new BABYLON.Color4(0, 0, 0, 0)

    const mat = new BABYLON.StandardMaterial("mat", scene)
          mat.emissiveColor = new BABYLON.Color3(0, 1, 0)

    const ma2 = new BABYLON.StandardMaterial("mat", scene)
          ma2.emissiveColor = new BABYLON.Color3(1, 0, 0)

    this.$container = new Mesh('container', scene)
    this.$box = MeshBuilder.CreateBox("box", { height: .01, width: .5, depth: .01 }, scene) 
    this.$box.material = mat  

    this.$bx = MeshBuilder.CreateBox("bx", { height: .01, width: .01, depth: .01 }, scene) 
    this.$bx.material = ma2  

    // engine.runRenderLoop(() => { 
    //   this.updateGlasses()
    //   scene.render() 
    // })
    // engine.resize()

    console.log(scene.cameras[0].position);


    const obj = await SceneLoader.LoadAssetContainerAsync("/static/", "8thwall.glb", scene)
    const GLTF = obj.instantiateModelsToScene()
    const mesh = new Mesh('glasses', scene).addChild(GLTF.rootNodes[0])
          mesh.scaling = new BABYLON.Vector3(.54, .54, .54)
          mesh.position.y = -.025

    mesh.parent = this.$container
    this.$box.parent = this.$container
    this.$bx.parent = this.$container
    this.$bx.position.z = 1
    this.$bx.position.y = .05

    engine.runRenderLoop(() => { 
      // this.updateGlasses()
      scene.render() 
    })
    engine.resize()

    // const obj1 = await SceneLoader.LoadAssetContainerAsync("/static/", "casque.glb", scene)
    // const GLTF1 = obj1.instantiateModelsToScene()
    // const mesh1 = new Mesh('hemet', scene).addChild(GLTF1.rootNodes[0])
    // mesh1.scaling = new BABYLON.Vector3(.30, .30, .30)
    // mesh1.position.y = .215
    // mesh1.position.z = .25
    // mesh1.rotation.y = (Math.PI/180)*180
    // mesh1.rotation.x = (Math.PI/180)*17 
    // mesh1.parent = this.$container
    
    this.ready = true
  
    console.log('WorldBabylon is ready !!!');
    document.addEventListener('keypress', this.onKeyPress)
  },

  methods: {

    onKeyPress(event) {
      this.toogle = !this.toogle
    },

    updateGlasses(pos, _sc, rz, rx, ry) {

      // console.log(rz, rx,ry);

      const ratio = .0036
      const px = (160 - pos[0])*ratio
      const py = (120 - pos[1])*ratio
      const pz = pos[2]*ratio 
      const sc = _sc/100

      this.$container.rotation.z = (Math.PI/180)*(- rz)
      // this.$container.rotation.x = (Math.PI/180)*(this.$parent.rx)

      this.$container.rotation.x = (Math.PI/180)*(rx)
      this.$container.rotation.y = (Math.PI/180)*(ry)

      this.$container.position.x = px
      this.$container.position.y = py
      this.$container.position.z = pz
      this.$container.scaling = new BABYLON.Vector3(sc, sc, sc)

      // var q = BABYLON.Quaternion.FromEulerAngles(0, BABYLON.Tools.ToRadians(90) , 0)
      // this.$container.lookAt(new BABYLON.Vector3(this.$bx.position.x, this.$bx.position.y, this.$bx.position.z))

      // head.position.copy(transform.position)
      // head.setRotationFromQuaternion(transform.rotation)
      // head.scale.set(transform.scale, transform.scale, transform.scale)
      // // Update the nose position.
      // noseAttachment.position.copy(attachmentPoints.noseBridge.position)

    },

  }
}
</script>


<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

#renderCanvas
  outline 1px solid green
  position absolute
  // top calc(50px + 480px + 16px)
  top 50px
  left 13px
  width 640px
  height 480px

  &.over
    top 50px

</style>


